import { HeroSection } from "@/components/HeroSection";
import { PromptChips } from "@/components/PromptChips";
import { ChatContainer } from "@/components/ChatContainer";
import { ChatInput } from "@/components/ChatInput";
import { Footer } from "@/components/Footer";
import { useChat } from "@/hooks/useChat";

const AMBIENT_GLOW =
  "radial-gradient(50% 40% at 50% 0%, rgba(12,176,181,0.16) 0%, rgba(9,16,26,0) 70%), radial-gradient(45% 45% at 100% 100%, rgba(245,165,36,0.10) 0%, rgba(9,16,26,0) 70%)";

export default function ChatPage() {
  const { messages, status, errorMsg, isBusy, send } = useChat();

  return (
    <div className="relative min-h-screen">
      <div
        className="pointer-events-none fixed inset-0 z-0"
        style={{ background: AMBIENT_GLOW }}
      />
      <div className="grain-overlay" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col min-h-screen">
        <HeroSection />

        <main className="flex-1 flex flex-col max-w-3xl w-full mx-auto">
          <div className="rounded-3xl border border-[#1e293b] bg-[#121b29]/65 backdrop-blur-2xl shadow-2xl flex flex-col overflow-hidden">
            <ChatContainer messages={messages} status={status} errorMsg={errorMsg} />
            <ChatInput onSend={send} disabled={isBusy} />
          </div>

          {messages.length === 0 && (
            <div className="mt-6">
              <PromptChips onSelect={send} disabled={isBusy} />
            </div>
          )}
        </main>

        <Footer />
      </div>
    </div>
  );
}
